const text = {
  primary: `It=was=magnificence=and=squalor The=daylight=fathered=meaning Light=was=the=story=and=the=telling The=sun=came=down=from=above It=sculpted=the=sculptor It=created=sight Its=illuminated=shores=marched=to=the=sea It=handed=out=clarity It=overpowered=the=blanks It=emptied=the=blind=prisons It=hunted=down=the=shadows It=was=kingmaker=and=king It=elevated=the=hours The=light=of=day=was=magistrate It=invented=vermilion It=invented=violet=and=gold It=was=the=proof Its=fields=threw=flowers=at=the=sky It=scattered=gold=coins It=scattered=yellow=seed`,
  default: `how=many=millions=stirred=at=its=first=touch? it=came=in=silence+it=left=in=silence its=kiss=still=lingers+on=the=surfaces electric=surrogates+have=crept=out=of=hiding may=it=find=peace now=we=sink=into=conjecture now=the=windows=have=emptied now=the=city=is=roughly=translated now=we=descend now=there=are=sunless=hypotheses there's=a=long=journey=back now=the=gray=wait=has=begun sleep=readies=its=back=office night=starts=its=experiments now=we've=become=theory now=there's=implacable=erasure shapes=melting`,
  fast: `departure haze vague formlessness indistinct dark drained eviscerated fading expired passed=on ended colorless emptiness unnamed anonymous murky dim shades tenebrous gloom dusk charcoal impenetrable bottomless unnavigable somber sunless opacity obscurity`,
}

const aliases = [
  [['primaryStrings1'], 'primary'],
]

const important = ['primary']

const styles = {primary: 'emphasized'}

export default {
  text,
  aliases,
  styles,
  important,
}